export type Tier = "quick-win" | "major-projects" | "fill-ins" | "avoid";

export interface ImpactEffortScale {
  readonly min: number;
  readonly max: number;
  readonly midpoint: number;
  readonly step: number;
  /** Omission retains the shared high-to-low effort axis. */
  readonly effortDirection?: "ascending" | "descending";
  readonly displayDecimals?: number;
}

export const DEFAULT_SCALE: ImpactEffortScale = {
  min: 0,
  max: 10,
  midpoint: 5,
  step: 0.1,
};

export function tierFor(
  impact: number,
  effort: number,
  scale: ImpactEffortScale = DEFAULT_SCALE,
): Tier {
  if (impact > scale.midpoint && effort <= scale.midpoint) return "quick-win";
  if (impact > scale.midpoint && effort > scale.midpoint)
    return "major-projects";
  if (impact <= scale.midpoint && effort <= scale.midpoint) return "fill-ins";
  return "avoid";
}

export function formatImpactEffortScore(
  value: number,
  scale: ImpactEffortScale,
): string {
  return scale.displayDecimals === undefined
    ? String(value)
    : value.toFixed(scale.displayDecimals);
}
